
import { Coupon, CouponType } from '../types';

export const couponService = {
  getStoreCoupons: (storeId: string): Coupon[] => {
    const data = localStorage.getItem('lynqar_coupons');
    const all: Coupon[] = data ? JSON.parse(data) : [];
    return all.filter(c => c.storeId === storeId);
  },

  createCoupon: (data: Omit<Coupon, 'id' | 'usageCount'>) => {
    const allData = localStorage.getItem('lynqar_coupons');
    const all: Coupon[] = allData ? JSON.parse(allData) : [];
    const newCoupon: Coupon = { 
      ...data, 
      id: 'cpn-' + Date.now(),
      usageCount: 0,
      code: data.code.toUpperCase().trim()
    };
    all.push(newCoupon);
    localStorage.setItem('lynqar_coupons', JSON.stringify(all));
    return newCoupon;
  },

  deleteCoupon: (id: string) => {
    const allData = localStorage.getItem('lynqar_coupons');
    if (!allData) return;
    const all: Coupon[] = JSON.parse(allData);
    const filtered = all.filter(c => c.id !== id);
    localStorage.setItem('lynqar_coupons', JSON.stringify(filtered));
  },

  validateCoupon: (code: string, storeId: string, orderTotal: number): { isValid: boolean; coupon?: Coupon; error?: string } => {
    const coupons = couponService.getStoreCoupons(storeId);
    const coupon = coupons.find(c => c.code === code.toUpperCase().trim());

    if (!coupon) return { isValid: false, error: 'Coupon code valid nahi hai, bhai.' };
    if (!coupon.isActive) return { isValid: false, error: 'Ye coupon abhi active nahi hai.' };
    
    const now = new Date();
    if (new Date(coupon.expiryDate) < now) return { isValid: false, error: 'Bhai, ye coupon expire ho chuka hai.' };
    
    if (orderTotal < coupon.minOrderValue) return { isValid: false, error: `Is coupon ke liye kam se kam $${coupon.minOrderValue} ka order chahiye.` };
    
    if (coupon.maxUsage && coupon.usageCount >= coupon.maxUsage) return { isValid: false, error: 'Coupon limit reach ho gayi hai.' };

    return { isValid: true, coupon };
  },

  calculateDiscount: (coupon: Coupon, subtotal: number): number => {
    if (coupon.type === 'PERCENTAGE') {
      return (subtotal * coupon.value) / 100;
    }
    return Math.min(coupon.value, subtotal);
  },

  incrementUsage: (couponId: string) => {
    const allData = localStorage.getItem('lynqar_coupons');
    if (!allData) return;
    const all: Coupon[] = JSON.parse(allData);
    const updated = all.map(c => c.id === couponId ? { ...c, usageCount: c.usageCount + 1 } : c);
    localStorage.setItem('lynqar_coupons', JSON.stringify(updated));
  }
};
